<script setup lang="ts">
/**
 * `ConfirmationDarkView.vue` — port of `ConfirmationDarkView.prefab`.
 *
 * Unity ships this as a SECOND prefab over the same `ConfirmationViewModel`,
 * differing only in palette: scrim `rgb(0.180) @ 0.651`, card `rgb(0.2392)`,
 * divider `rgb(0.3647)`. Call sites pick it by view name
 * (`ViewNames.ConfirmationDark`) — used for clear-cache, sign-out, and the
 * sketch discard prompt.
 *
 * The web keeps the file for name parity with `ViewNames.cs` but implements it
 * as `ConfirmationView` with `theme: "dark"` forced, rather than duplicating
 * the markup. Note the web port's whole chrome is already the dark desktop
 * skin, so the two variants are much closer here than in Unity.
 */
import ConfirmationView from "./ConfirmationView.vue";
import type {
  ConfirmationArgs,
  ConfirmationResult,
} from "@models/notifications/IConfirmationModel";

defineOptions({ name: "ConfirmationDarkView" });

const props = defineProps<{ args: ConfirmationArgs }>();
const emit = defineEmits<{
  (e: "answer", result: ConfirmationResult, suppress: boolean): void;
}>();
</script>

<template>
  <ConfirmationView
    :args="{ ...props.args, theme: 'dark' }"
    @answer="(r: ConfirmationResult, s: boolean) => emit('answer', r, s)"
  />
</template>
